export default __webpack_public_path__ + "assets/mali-flag.png";